import React, { useState } from 'react';

import { Grid, Typography, TextField } from '@mui/material';
import { greyOutEmptyTextField } from '../../Helpers/helpers';

const ICLPaperWorkChecks = (props) => {
  const handleChange = props.handleChange;

  const [jcSigned, set_jcSigned] = useState(props.data.jcSigned);
  const [soSigned, set_soSigned] = useState(props.data.soSigned);
  const [grnIssued, set_grnIssued] = useState(props.data.grnIssued);
  const [gasUsage, set_gasUsage] = useState(props.data.gasUsage);
  const [hotWorks, set_hotWorks] = useState(props.data.hotWorks);
  const [coc, set_coc] = useState(props.data.coc);

  const handleElementChange = (val, item) => {
    switch (item) {
      case 'jcSigned':
        set_jcSigned(val);
        break;
      case 'soSigned':
        set_soSigned(val);
        break;
      case 'grnIssued':
        set_grnIssued(val);
        break;
      case 'gasUsage':
        set_gasUsage(val);
        break;
      case 'hotWorks':
        set_hotWorks(val);
        break;
      case 'coc':
        set_coc(val);
        break;

      default:
        break;
    }
    handleChange(val, item);
  };

  return (
    <Grid
      container
      rowSpacing={0}
      margin={0}
      columnSpacing={{ xs: 0 }}
      rowGap={0}
      style={{ marginLeft: 0, marginRight: 0 }}
    >
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderBottom: 'none',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='left'
        >
          Job Card Stamped & Signed
        </Typography>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderLeft: 'none',
          borderBottom: 'none',
          background: greyOutEmptyTextField(jcSigned)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='jcSigned'
          value={jcSigned}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{
            borderBottom: 'none',
            textAlign: 'left',
            '& fieldset': { border: 'none' },
          }}
          size='small'
        ></TextField>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderBottom: 'none',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='left'
        >
          Store Order Stamped & Signed
        </Typography>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderLeft: 'none',
          borderBottom: 'none',
          background: greyOutEmptyTextField(soSigned)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='soSigned'
          value={soSigned}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{
            borderBottom: 'none',
            textAlign: 'left',
            '& fieldset': { border: 'none' },
          }}
          size='small'
        ></TextField>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderBottom: 'none',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='left'
        >
          GRN Nr Issued
        </Typography>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderLeft: 'none',
          borderBottom: 'none',
          background: greyOutEmptyTextField(grnIssued)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='grnIssued'
          value={grnIssued}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{
            borderBottom: 'none',
            textAlign: 'left',
            '& fieldset': { border: 'none' },
          }}
          size='small'
        ></TextField>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderBottom: 'none',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='left'
        >
          WI Gas Usage Page Stamped & Signed
        </Typography>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderLeft: 'none',
          borderBottom: 'none',
          background: greyOutEmptyTextField(gasUsage)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='gasUsage'
          value={gasUsage}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{
            borderBottom: 'none',
            textAlign: 'left',
            '& fieldset': { border: 'none' },
          }}
          size='small'
        ></TextField>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderBottom: 'none',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='left'
        >
          WI Hot Works Permit Stamped & Signed
        </Typography>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderLeft: 'none',
          borderBottom: 'none',
          background: greyOutEmptyTextField(hotWorks)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='hotWorks'
          value={hotWorks}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{
            borderBottom: 'none',
            textAlign: 'left',
            '& fieldset': { border: 'none' },
          }}
          size='small'
        ></TextField>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
        }}
        item
        xs={4}
        md={4}
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='left'
        >
          COC Completed
        </Typography>
      </Grid>
      <Grid
        sx={{
          textAlign: 'left',
          border: 'solid black 1px',
          borderLeft: 'none',
          background: greyOutEmptyTextField(coc)
        }}
        item
        xs={8}
        md={8}
      >
        <TextField
          id='coc'
          value={coc}
          onChange={(event) =>
            handleElementChange(event.target.value, event.target.id)
          }
          fullWidth
          sx={{
            borderBottom: 'none',
            textAlign: 'left',
            '& fieldset': { border: 'none' },
          }}
          size='small'
        ></TextField>
      </Grid>
    </Grid>
  );
};

export default ICLPaperWorkChecks;
